import { PercentPipe } from '@angular/common';
import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';

/**
 * Wraps `PercentPipe` with `digitsInfo` `'1.0-2'`, so the two-decimal convention lives in one
 * place instead of every read-only display repeating the literal. See AGENTS.md.
 *
 * ```html
 * {{ site.destinationShare | fsfPercent }}  <!-- 0.6725 → "67,25 %", 0.5 → "50 %" -->
 * ```
 */
@Pipe({ name: 'fsfPercent', standalone: true })
export class FsfPercentPipe implements PipeTransform {
  // From the ambient LOCALE_ID, so the pipe needs no PercentPipe provider of its own.
  readonly #percent = new PercentPipe(inject(LOCALE_ID));

  transform(value: number | null | undefined): string | null {
    return this.#percent.transform(value, '1.0-2');
  }
}
